import {
  Flex,
  Grid,
  GridItem,
  Icon,
  Text,
  Button,
  useBreakpointValue,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FOLDER_CONTENTS, MY_FOLDERS } from "../../_utils/routes";
import FolderCard from "./FolderCard";
import { lightInactive } from "../styled/variable";
import { useTranslation } from "react-i18next";
import Format from 'string-format';
import { fetchFolders } from "../../_actions/folderActions";
import axios from "axios";

const RecentFoldersRow = ({ parentLocation }) => {
  const signal = axios.CancelToken.source();
  const { t } = useTranslation(["common"]);
  const history = useHistory();
  const recentFolders = useSelector((state) => state.folders.recent);
  const folders = useSelector((state) => state.folders.folders);
  const page = useSelector((state) => state.folders.foldersPage);
  const dispatch = useDispatch();
  const isSmallScreen = useBreakpointValue({ base: true, md: false });

  useEffect(() => {
    if (folders.length === 0) {
      const payload = {
        searchTerm: "",
        props: {
          ...folders,
          foldersPage: page,
        },
        updateRecent: true,
      };
      dispatch(fetchFolders(payload, signal.token));
    }
  }, []);

  function handleViewAllClick() {
    history.push(MY_FOLDERS);
  };

  function handleOnFolderClick(folder) {
    const url = Format(FOLDER_CONTENTS, folder.id);

    history.push({
      pathname: encodeURI(url),
      state: {
        folder: folder,
        parent: parentLocation,
      },
    });
  };

  return (
    <Flex direction="column">
      {recentFolders.length > 0 ? (
        <Flex
          w="100%"
          direction="row"
          align="center"
          justify="space-between"
          mb="1rem"
        >
          <Text
            sx={{
              fontWeight: "500",
              color: "gray.100",
              fontSize: "1.125rem",
            }}
          >
            {t("folders")}
          </Text>
          <Button
            variant="link"
            onClick={handleViewAllClick}
            rightIcon={<Icon as={FaArrowRight} />}
            color="gray.100"
            size="sm"
          >
            {t("view_all")}
          </Button>
        </Flex>
      ) : null}

      <Grid
        templateColumns={
          isSmallScreen
            ? "repeat(auto-fill, minmax(150px, 1fr))"
            : "repeat(auto-fill, minmax(200px, 1fr))"
        }
        gap="15px"
        pb={recentFolders.length > 0 ? "2.5rem" : ""}
      >
        {recentFolders.length > 0 ? (
          <>
            {recentFolders.map((folder) => (
              <GridItem color={lightInactive} key={folder.id}>
                <FolderCard
                  key={folder.id}
                  folder={folder}
                  onClick={() => handleOnFolderClick(folder)}
                  maxWidth={isSmallScreen ? "90px" : "135px"}
                />
              </GridItem>
            ))}
          </>
        ) : null}
      </Grid>
    </Flex>
  );
};

export default RecentFoldersRow;
